import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "superscript-icon",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M20.0414 3.55718C20.3217 3.67323 20.5045 3.94674 20.5045 4.25014V8.50226H21C21.4142 8.50226 21.75 8.83804 21.75 9.25226C21.75 9.66647 21.4142 10.0023 21 10.0023H18.509C18.0948 10.0023 17.759 9.66647 17.759 9.25226C17.759 8.83804 18.0948 8.50226 18.509 8.50226H19.0045V6.06014C18.7101 6.32346 18.2578 6.31386 17.9749 6.03121C17.6819 5.73843 17.6817 5.26356 17.9745 4.97055L19.224 3.72003C19.4384 3.5054 19.7611 3.44113 20.0414 3.55718Z" }, null, -1),
    _createElementVNode("path", { d: "M2.25 7.75012C2.25 7.33591 2.58579 7.00012 3 7.00012H15C15.4142 7.00012 15.75 7.33591 15.75 7.75012C15.75 8.16434 15.4142 8.50012 15 8.50012H9.7525V19.7501C9.7525 20.1643 9.41672 20.5001 9.0025 20.5001C8.58829 20.5001 8.2525 20.1643 8.2525 19.7501V8.50012H3C2.58579 8.50012 2.25 8.16434 2.25 7.75012Z" }, null, -1)
  ])))
}
export default { render: render }